/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * CartControllerV4Api - axios parameter creator
 */
export const CartControllerV4ApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {CartServiceCartGetCartLocalizedV4DistributionTypeEnum} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartGetCartLocalizedV4: (language_1, tenant_1, Accept_Language_1, purgeMessages_1, nowZipCode_1, isNowSelected_1, slotId_1, includeMaxDosage_1, distributionType_1, ...args_1) => __awaiter(this, [language_1, tenant_1, Accept_Language_1, purgeMessages_1, nowZipCode_1, isNowSelected_1, slotId_1, includeMaxDosage_1, distributionType_1, ...args_1], void 0, function* (language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('cartServiceCartGetCartLocalizedV4', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartServiceCartGetCartLocalizedV4', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartServiceCartGetCartLocalizedV4', 'Accept_Language', Accept_Language);
            const localVarPath = `/{language}/cart/v4/{tenant}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create multiple cartEntries
         * @param {string} language
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {CartServiceCartPostAddToCartEntriesLocalizedDistributionTypeEnum} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostAddToCartEntriesLocalized: (language_1, tenant_1, Accept_Language_1, CartV2CartEntriesRequestV1_1, purgeMessages_1, nowZipCode_1, isNowSelected_1, slotId_1, distributionType_1, includeMaxDosage_1, ...args_1) => __awaiter(this, [language_1, tenant_1, Accept_Language_1, CartV2CartEntriesRequestV1_1, purgeMessages_1, nowZipCode_1, isNowSelected_1, slotId_1, distributionType_1, includeMaxDosage_1, ...args_1], void 0, function* (language, tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('cartServiceCartPostAddToCartEntriesLocalized', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartServiceCartPostAddToCartEntriesLocalized', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartServiceCartPostAddToCartEntriesLocalized', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartEntriesRequestV1' is not null or undefined
            assertParamExists('cartServiceCartPostAddToCartEntriesLocalized', 'CartV2CartEntriesRequestV1', CartV2CartEntriesRequestV1);
            const localVarPath = `/{language}/cart/v4/{tenant}/entries`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartEntriesRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * create or update cartEntry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {CartServiceCartPostAddToCartEntryLocalizedDistributionTypeEnum} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostAddToCartEntryLocalized: (language_1, tenant_1, Accept_Language_1, CartV2CartEntryRequestV1_1, purgeMessages_1, nowZipCode_1, isNowSelected_1, slotId_1, distributionType_1, includeMaxDosage_1, ...args_1) => __awaiter(this, [language_1, tenant_1, Accept_Language_1, CartV2CartEntryRequestV1_1, purgeMessages_1, nowZipCode_1, isNowSelected_1, slotId_1, distributionType_1, includeMaxDosage_1, ...args_1], void 0, function* (language, tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('cartServiceCartPostAddToCartEntryLocalized', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('cartServiceCartPostAddToCartEntryLocalized', 'tenant', tenant);
            // verify required parameter 'Accept_Language' is not null or undefined
            assertParamExists('cartServiceCartPostAddToCartEntryLocalized', 'Accept_Language', Accept_Language);
            // verify required parameter 'CartV2CartEntryRequestV1' is not null or undefined
            assertParamExists('cartServiceCartPostAddToCartEntryLocalized', 'CartV2CartEntryRequestV1', CartV2CartEntryRequestV1);
            const localVarPath = `/{language}/cart/v4/{tenant}/entry`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (purgeMessages !== undefined) {
                localVarQueryParameter['purgeMessages'] = purgeMessages;
            }
            if (nowZipCode !== undefined) {
                localVarQueryParameter['nowZipCode'] = nowZipCode;
            }
            if (isNowSelected !== undefined) {
                localVarQueryParameter['isNowSelected'] = isNowSelected;
            }
            if (slotId !== undefined) {
                localVarQueryParameter['slotId'] = slotId;
            }
            if (distributionType !== undefined) {
                localVarQueryParameter['distributionType'] = distributionType;
            }
            if (includeMaxDosage !== undefined) {
                localVarQueryParameter['includeMaxDosage'] = includeMaxDosage;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (Accept_Language != null) {
                localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(CartV2CartEntryRequestV1, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * get total number of entries in the cart
         * @param {string} language
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV4TenantMinicartGet: (language_1, tenant_1, ...args_1) => __awaiter(this, [language_1, tenant_1, ...args_1], void 0, function* (language, tenant, options = {}) {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('languageCartV4TenantMinicartGet', 'language', language);
            // verify required parameter 'tenant' is not null or undefined
            assertParamExists('languageCartV4TenantMinicartGet', 'tenant', tenant);
            const localVarPath = `/{language}/cart/v4/{tenant}/minicart`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)))
                .replace(`{${"tenant"}}`, encodeURIComponent(String(tenant)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CartControllerV4Api - functional programming interface
 */
export const CartControllerV4ApiFp = function (configuration) {
    const localVarAxiosParamCreator = CartControllerV4ApiAxiosParamCreator(configuration);
    return {
        /**
         * Get new or existing cart for customer (including guests)
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {CartServiceCartGetCartLocalizedV4DistributionTypeEnum} [distributionType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartGetCartLocalizedV4(language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartServiceCartGetCartLocalizedV4(language, tenant, Accept_Language, purgeMessages, nowZipCode, isNowSelected, slotId, includeMaxDosage, distributionType, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV4Api.cartServiceCartGetCartLocalizedV4']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * create multiple cartEntries
         * @param {string} language
         * @param {string} tenant
         * @param {string} Accept_Language
         * @param {CartV2CartEntriesRequestV1} CartV2CartEntriesRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {CartServiceCartPostAddToCartEntriesLocalizedDistributionTypeEnum} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostAddToCartEntriesLocalized(language, tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartServiceCartPostAddToCartEntriesLocalized(language, tenant, Accept_Language, CartV2CartEntriesRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV4Api.cartServiceCartPostAddToCartEntriesLocalized']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * create or update cartEntry
         * @param {string} language
         * @param {string} tenant The tenant, e.g. com-dev or com.
         * @param {string} Accept_Language
         * @param {CartV2CartEntryRequestV1} CartV2CartEntryRequestV1
         * @param {boolean} [purgeMessages]
         * @param {string} [nowZipCode]
         * @param {boolean} [isNowSelected]
         * @param {string} [slotId]
         * @param {CartServiceCartPostAddToCartEntryLocalizedDistributionTypeEnum} [distributionType]
         * @param {boolean} [includeMaxDosage] if true, maxdosage service will be requested to fetch the limits on the individual products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostAddToCartEntryLocalized(language, tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cartServiceCartPostAddToCartEntryLocalized(language, tenant, Accept_Language, CartV2CartEntryRequestV1, purgeMessages, nowZipCode, isNowSelected, slotId, distributionType, includeMaxDosage, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV4Api.cartServiceCartPostAddToCartEntryLocalized']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         * get total number of entries in the cart
         * @param {string} language
         * @param {string} tenant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV4TenantMinicartGet(language, tenant, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.languageCartV4TenantMinicartGet(language, tenant, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = operationServerMap['CartControllerV4Api.languageCartV4TenantMinicartGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
/**
 * CartControllerV4Api - factory interface
 */
export const CartControllerV4ApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CartControllerV4ApiFp(configuration);
    return {
        /**
         * Get new or existing cart for customer (including guests)
         * @param {CartControllerV4ApiCartServiceCartGetCartLocalizedV4Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartGetCartLocalizedV4(requestParameters, options) {
            return localVarFp.cartServiceCartGetCartLocalizedV4(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.includeMaxDosage, requestParameters.distributionType, options).then((request) => request(axios, basePath));
        },
        /**
         * create multiple cartEntries
         * @param {CartControllerV4ApiCartServiceCartPostAddToCartEntriesLocalizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostAddToCartEntriesLocalized(requestParameters, options) {
            return localVarFp.cartServiceCartPostAddToCartEntriesLocalized(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntriesRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(axios, basePath));
        },
        /**
         * create or update cartEntry
         * @param {CartControllerV4ApiCartServiceCartPostAddToCartEntryLocalizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cartServiceCartPostAddToCartEntryLocalized(requestParameters, options) {
            return localVarFp.cartServiceCartPostAddToCartEntryLocalized(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(axios, basePath));
        },
        /**
         * get total number of entries in the cart
         * @param {CartControllerV4ApiLanguageCartV4TenantMinicartGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        languageCartV4TenantMinicartGet(requestParameters, options) {
            return localVarFp.languageCartV4TenantMinicartGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CartControllerV4Api - object-oriented interface
 */
export class CartControllerV4Api extends BaseAPI {
    /**
     * Get new or existing cart for customer (including guests)
     * @param {CartControllerV4ApiCartServiceCartGetCartLocalizedV4Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartServiceCartGetCartLocalizedV4(requestParameters, options) {
        return CartControllerV4ApiFp(this.configuration).cartServiceCartGetCartLocalizedV4(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.includeMaxDosage, requestParameters.distributionType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create multiple cartEntries
     * @param {CartControllerV4ApiCartServiceCartPostAddToCartEntriesLocalizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartServiceCartPostAddToCartEntriesLocalized(requestParameters, options) {
        return CartControllerV4ApiFp(this.configuration).cartServiceCartPostAddToCartEntriesLocalized(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntriesRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * create or update cartEntry
     * @param {CartControllerV4ApiCartServiceCartPostAddToCartEntryLocalizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    cartServiceCartPostAddToCartEntryLocalized(requestParameters, options) {
        return CartControllerV4ApiFp(this.configuration).cartServiceCartPostAddToCartEntryLocalized(requestParameters.language, requestParameters.tenant, requestParameters.Accept_Language, requestParameters.CartV2CartEntryRequestV1, requestParameters.purgeMessages, requestParameters.nowZipCode, requestParameters.isNowSelected, requestParameters.slotId, requestParameters.distributionType, requestParameters.includeMaxDosage, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * get total number of entries in the cart
     * @param {CartControllerV4ApiLanguageCartV4TenantMinicartGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    languageCartV4TenantMinicartGet(requestParameters, options) {
        return CartControllerV4ApiFp(this.configuration).languageCartV4TenantMinicartGet(requestParameters.language, requestParameters.tenant, options).then((request) => request(this.axios, this.basePath));
    }
}
export const CartServiceCartGetCartLocalizedV4DistributionTypeEnum = {
    None: 'none',
    Delivery: 'delivery',
    Pickup: 'pickup'
};
export const CartServiceCartPostAddToCartEntriesLocalizedDistributionTypeEnum = {
    None: 'none',
    Delivery: 'delivery',
    Pickup: 'pickup'
};
export const CartServiceCartPostAddToCartEntryLocalizedDistributionTypeEnum = {
    None: 'none',
    Delivery: 'delivery',
    Pickup: 'pickup'
};
